import React from 'react';
import { IconMenu } from '../../components';
import s from './HostStyles.module.scss';

const options = [
    {
        label: 'foo',
        onSelect: () => console.log('foo'),
        icon: 'icon-duplicate-POI',
    },
    {
        label: 'bar',
        onSelect: () => console.log('bar'),
        icon: 'icon-duplicate-POI',
    },
];

const props = top => ({
    className: s.editor,
    style: {
        marginTop: top,
        marginLeft: 200,
    },
});

const IconMenuHost = () => (
    <div>
        <div {...props(30)}>
            <div>V4 Version</div>
            <IconMenu isV5={false} options={options} />
        </div>

        <div {...props(120)}>
            <div>V5 Version</div>
            <IconMenu isV5 options={options} />
        </div>
    </div>
);

export default IconMenuHost;
